import * as actionTypes from '../actionTypes/default';

export const fetchDefault = () => ({
  type: actionTypes.FETCH_DEFAULT,
});

export const fetchDefaultFulfilled = payload => ({
  type: actionTypes.FETCH_DEFAULT_FULFILLED,
  payload,
});

export const fetchDefaultRejected = payload => ({
  type: actionTypes.FETCH_DEFAULT_REJECTED,
  payload,
});
